<template>
  <svg :width="width" :height="height" viewBox="0 0 100 4">
    <line
      x1="0"
      y1="2"
      x2="100"
      y2="2"
      :stroke="color"
      :stroke-width="strokeWidth"
      :stroke-dasharray="dashArray"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'LineBorderSvg',
  props: {
    color: { type: String, default: '#FF974C' },
    dash: { type: Array, default: () => [0, 0] },
    width: { type: [Number, String], default: 100 },
    height: { type: [Number, String], default: 4 },
    strokeWidth: { type: [Number, String], default: 2 },
  },
  computed: {
    dashArray() {
      return this.dash.join(',');
    },
  },
};
</script>
